import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";

import { hasItems } from "../../../../helpers/Utils";
import ListingOverview from "../details/overview/ListingOverview";
import ListingDraftHeader from "./header/ListingDraftHeader";
import RelatedListings from "../details/related/RelatedListings";

import ListingDraftPreview from "./preview/ListingDraftPreview";

import s from "./ListingDraft.module.scss";

export default function ListingDraft() {
	const history = useHistory();

	const [showPreview, setShowPreview] = useState(false);

	const market = useSelector((state) => state.market || {});
	const listing = market.draftListing;
	const relatedProducts = market.listings || [];

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	// ------------------------------------- DATA -------------------------------------
	if (!listing) {
		history.goBack();
		return null;
	}

	return showPreview ? (
		<ListingDraftPreview
			product={listing}
			goBack={() => setShowPreview(false)}
		/>
	) : (
		<div className={s.root}>
			<ListingDraftHeader
				listing={listing}
				onPreview={
					listing?.marketPreviewFile?.content
						? () => setShowPreview(true)
						: null
				}
			/>

			<div className={s.pageContent}>
				<ListingOverview product={listing} />

				{hasItems(relatedProducts) && (
					<RelatedListings product={listing} products={relatedProducts} />
				)}
			</div>
		</div>
	);
}
